import * as React from 'react';
import { Field, FieldProps } from '../Field';
import { Input, InputProps } from '../Input/Input';

export type TextFieldProps = InputProps & FieldProps;

/**
 * TextField is a composition of `Field` and `Input` component.
 * If you wish to have more control, you can compose them yourself.
 */
export const TextField = React.forwardRef<HTMLInputElement, TextFieldProps>(function TextFieldComp(
  {
    label,
    wrapperClassName,
    status,
    maxWidth,
    compact,
    helpText,
    alwaysShowHelpText,
    errorHelpText,
    tooltip,
    tooltipAvoidPositions,
    ...inputProps
  },
  ref
) {
  return (
    <Field
      status={status}
      label={label}
      maxWidth={maxWidth}
      wrapperClassName={wrapperClassName}
      compact={compact}
      alwaysShowHelpText={alwaysShowHelpText}
      helpText={helpText}
      errorHelpText={errorHelpText}
      required={inputProps.required}
      tooltip={tooltip}
      tooltipAvoidPositions={tooltipAvoidPositions}
      inputId={inputProps.id}
      renderInput={({ getInputProps }) => <Input {...getInputProps({ ...inputProps, ref })} />}
    />
  );
});
